import { render, staticRenderFns } from "./SalesOrderViewDetails.vue?vue&type=template&id=a44a80cc&"
import script from "./SalesOrderViewDetails.vue?vue&type=script&lang=js&"
export * from "./SalesOrderViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports